import React, { useEffect, useState } from "react";
import SidebarLayout from "../../../common/sidebar/SidebarLayout";
import { Helmet } from "../../../common/Helmet";
import { ReactComponent as DownloadIcon } from "../../../../assets/icons/TestAccounts.svg";
import OPSPrimaryHeader from "../../../common/primaryHeader/OPSPrimaryHeader";
import CliniciansDataTable from "./CliniciansDataTable";
import {
  fetchAllClinicAdmins,
  getClinicianData,
  getClinicianDataCSV,
} from "../../../../store/features/ops/opsSlice";
import PatientLoader from "../../../common/PatientLoader";
import { notify } from "../../../../util/helpers";

const Clinicians = () => {
  const [hideDemoAccounts, setHideDemoAccounts] = useState(false);
  const [clinicians, setClinicians] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDownloading, setIsDownloading] = useState(false);
  const downloadCSVData = (months) => {
    if (isDownloading) {
      notify("File generation is in progress, please wait..", "info");
      return;
    }
    notify("Your file will be ready shortly..", "info");
    getClinicianDataCSV()
      .then((res) => {
        if (res.status === 200) {
          window.open(res?.data?.url);
        }
        setIsDownloading(false);
      })
      .catch((e) => {
        console.log(e);
        notify("Something went wrong! Try again later!", "error");
        setIsDownloading(false);
      });
  };

  useEffect(() => {
    getClinicianData()
      .then((res) => {
        setClinicians(res?.data?.data);
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        notify("Something went wrong while gathering your data!", "error");
        setLoading(false);
      });
  }, []);

  return (
    <SidebarLayout>
      <section className="contianer-fluid px-5 py-2">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Clinician List | Precise Digital</title>
          <link rel="canonical" href={window.location.origin} />
        </Helmet>
        <div
          className="container-fluid px-3 d-flex justify-content-between"
          style={{ alignContent: "center", alignItems: "center" }}
        >
          <OPSPrimaryHeader
            titleText={`Clinician List`}
            showSubtitle={false}
            showButton={false}
            showPill={true}
            pillText={`${clinicians?.length} Entries`}
          />
          <div
            className="d-flex"
            style={{
              gap: "20px",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <div className="d-flex " style={{ gap: "10px" }}>
              <label className="switch-small">
                <input
                  disabled={false}
                  onChange={() => {
                    setHideDemoAccounts(!hideDemoAccounts);
                  }}
                  checked={hideDemoAccounts}
                  type="checkbox"
                />
                <span className="slider-small round"></span>
              </label>
              <span className="muted-text">Show Demo Accounts</span>
            </div>
            <button
              disabled={isDownloading}
              onClick={() => {
                downloadCSVData(12);
              }}
              className="primary-btn d-flex"
              style={{ gap: "10px" }}
            >
              <DownloadIcon /> Download
            </button>
          </div>
        </div>

        {loading ? (
          <PatientLoader />
        ) : (
          <CliniciansDataTable
            hideDemoAccounts={hideDemoAccounts}
            data={clinicians}
            loading={loading}
          />
        )}
      </section>
    </SidebarLayout>
  );
};

export default Clinicians;
